
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["initialize","initializeSliceView","loadSlices","displaySlice","resizeCanvas","setImageView","setWindow","dispose"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "sliceImageLoader.89c15630.worker.js", { name: "sliceImageLoader.[contenthash:8].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			